import { render, staticRenderFns } from "./feeApply.vue?vue&type=template&id=b37318fe&scoped=true&"
import script from "./feeApply.vue?vue&type=script&lang=js&"
export * from "./feeApply.vue?vue&type=script&lang=js&"
import style0 from "./feeApply.vue?vue&type=style&index=0&id=b37318fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37318fe",
  null
  
)

export default component.exports